/**
 * Product Card Swipe - Hybrid Version
 * Only activates for products with multiple images
 * Preserves all original functionality
 */

class ProductCardSwipe {
  constructor(element) {
    this.container = element;
    this.slides = this.container.querySelectorAll('.product-card-swipe__slide');
    this.prevButton = this.container.querySelector('.product-card-swipe__arrow--prev');
    this.nextButton = this.container.querySelector('.product-card-swipe__arrow--next');
    
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    
    if (this.totalSlides <= 1) {
      return; // No swipe needed for single images
    }
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.updateSlides();
  }
  
  bindEvents() {
    // Arrow navigation
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToPrev();
      });
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToNext();
      });
    }
  }
  
  goToPrev() {
    this.currentIndex = this.currentIndex === 0 ? this.totalSlides - 1 : this.currentIndex - 1;
    this.updateSlides();
  }
  
  goToNext() {
    this.currentIndex = this.currentIndex === this.totalSlides - 1 ? 0 : this.currentIndex + 1;
    this.updateSlides();
  }
  
  updateSlides() {
    this.slides.forEach((slide, index) => {
      if (index === this.currentIndex) {
        slide.classList.add('product-card-swipe__slide--active');
      } else {
        slide.classList.remove('product-card-swipe__slide--active');
      }
    });
  }
}

// Initialize on DOM ready and section reloads
function initProductCardSwipe() {
  const swipeContainers = document.querySelectorAll('[data-product-swipe]');
  
  swipeContainers.forEach(container => {
    // Avoid double initialization
    if (!container.hasAttribute('data-swipe-initialized')) {
      new ProductCardSwipe(container);
      container.setAttribute('data-swipe-initialized', 'true');
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initProductCardSwipe);

// Re-initialize on Shopify section reloads
document.addEventListener('shopify:section:load', initProductCardSwipe);
document.addEventListener('shopify:section:reorder', initProductCardSwipe);

// Export for external use if needed
window.ProductCardSwipe = ProductCardSwipe;